import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import api from '../../api';
import Loader from '../Loader/Loader';
import WithRouter from '../Extensions/WithRouter';

class ChangeRecoveryEmailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCR: props.isOpenMCR,
      modalAlert: false,
      isLoader: false,
      isAutoCompleteRecoveryEmail: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      recoveryEmail: '',
      recoveryEmailError: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleInputRecoveryEmail = this.handleInputRecoveryEmail.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleInputKeyPress = this.handleInputKeyPress.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCR } = this.props;
    if (prevProps.isOpenMCR !== isOpenMCR) {
      this.setState({
        isAutoCompleteRecoveryEmail: false,
        modalAlertMsg: '',
        modalAlertTitle: '',
        recoveryEmail: '',
        recoveryEmailError: '',
        isOpenMCR,
      });
    }
  }

  handleInputRecoveryEmail(e) {
    this.setState({
      recoveryEmail: e.target.value,
      recoveryEmailError: '',
    });
  }

  handleInputFocus() {
    this.setState({
      isAutoCompleteRecoveryEmail: true,
    });
  }

  handleInputKeyPress(event) {
    if (event.key === 'Enter') {
      this.onSubmit();
    }
  }

  handleCloseAlert() {
    const { translate } = this.props;
    const { modalAlertTitle } = this.state;
    if (modalAlertTitle === translate('modal.title.attention')) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.closeModal('refresh');
        }
      );
    }
  }

  onSubmit(event) {
    const { recoveryEmail } = this.state;
    const { translate } = this.props;

    if (event) {
      event.preventDefault();
    }
    if (!this.validateFields()) {
      return null;
    }
    this.setState({
      isLoader: true,
      modalAlert: true,
    });
    const data = {
      recovery_email: recoveryEmail,
    };

    api
      .recoveryEmailWithProfile(data)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertMsg: translate('modal.message.update_success_recovery'),
          modalAlertTitle: translate('modal.title.notice'),
        });
      })
      .catch((err) => {
        const o = err.data.response;
        if (o.error === '422-366') {
          return this.setState({
            isLoader: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
            recoveryEmailError: o.error_description,
          });
        }
        if (o.error_description) {
          this.setState({
            isLoader: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            modalAlertTitle: translate('modal.title.attention'),
            modalAlertMsg: translate('modal.error.unknow_error'),
          });
        }
      });
  }

  closeModal(string) {
    const { closeModal } = this.props;
    closeModal(string);
  }

  validateFields() {
    const { recoveryEmail } = this.state;
    const { translate } = this.props;
    const validation = {
      isRecoveryEmail: true,
    };

    if (recoveryEmail.trim().length === 0) {
      this.setState({
        recoveryEmailError: translate('modal.message.update_success_recovery'),
      });
      validation.isRecoveryEmail = false;
      return;
    }

    const isValidEmailAddressRegx = String(recoveryEmail).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    if (!isValidEmailAddressRegx) {
      this.setState({
        recoveryEmailError: translate('modal.error.invalid_email_address'),
      });
      validation.isRecoveryEmail = false;
      return;
    }
    return validation.isRecoveryEmail;
  }

  render() {
    const {
      recoveryEmailError,
      isAutoCompleteRecoveryEmail,
      recoveryEmail,
      isOpenMCR,
      isLoader,
      modalAlert,
      modalAlertTitle,
      modalAlertMsg,
    } = this.state;
    const { translate } = this.props;

    const showRecoveryEmailErrorClass = recoveryEmailError !== '' ? 'show' : '';

    //if (state.user.scanConfig.isLoading) {
    //      return <Loader />;
    //}

    return (
      <Modal open={isOpenMCR} onClose={this.closeModal}>
        <div className="profile_popup_wrap">
          <div className="profile_popup default_popup" style={{ height: '350px' }}>
            <div className="profile_popup_header">
              <h2 className="popup_name">
                {translate('profile.title.change_recovery_email')}
              </h2>
            </div>
            <div className="profile_popup_contents">
              <div className="profile_popup_content_wrap">
                <div className="profile_popup_content">
                  <p className="label">
                    {translate('profile.title.recovery_email')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <p className="value">
                    {!recoveryEmailError ? (
                      <input
                        type="text"
                        placeholder={translate('profile.message.recovery_email_placeholder')}
                        value={recoveryEmail}
                        onChange={this.handleInputRecoveryEmail}
                        onFocus={this.handleInputFocus}
                        onKeyPress={this.handleInputKeyPress}
                        readOnly={!isAutoCompleteRecoveryEmail}
                      />
                    ) : (
                      <input
                        type="text"
                        placeholder={translate('profile.title.recovery_email_addr')}
                        value={recoveryEmail}
                        onChange={this.handleInputRecoveryEmail}
                        onFocus={this.handleInputFocus}
                        onKeyPress={this.handleInputKeyPress}
                        style={{ border: '1px solid rgb(239, 65, 54)' }}
                        readOnly={!isAutoCompleteRecoveryEmail}
                      />
                    )}
                    <div
                      className={`error ${showRecoveryEmailErrorClass}`}
                      style={{
                        lineHeight: '20px',
                        marginLeft: '5px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#ef4136',
                      }}
                    >
                      {recoveryEmailError}
                    </div>
                  </p>
                </div>
              </div>
              <div className="profile_popup_button_wrap">
                <a
                  className="button cancel_button"
                  onClick={this.closeModal}
                  onKeyUp={this.closeModal}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onClick={this.onSubmit}
                  onKeyUp={this.onSubmit}
                >
                  {translate('modal.button.save')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <Modal open={modalAlert} onClose={this.handleCloseAlert}>
          {isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{modalAlertTitle}</h2>
                  <p className="text">{modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.handleCloseAlert}
                      onKeyUp={this.handleCloseAlert}
                    >
                      Ok
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}
export default WithRouter(inject('state')(observer(ChangeRecoveryEmailModal)));
